// Display name — the tier-0 author identity, per device.
//
// With no sign-in (local mode), the author's display name is a DEVICE
// preference like the theme (memory project_theme_outside_event_log): it is
// persisted to localStorage, never emitted as an event. These two functions
// are the whole seam; only the impure shell (AppShellHost) may call them —
// the Settings panels stay pure views fed the value via props.
//
// Empty string = "no name set yet" — the honest fresh-device state; the
// account panel renders a placeholder for it, never a fixture name.

import { readDeviceKey, writeDeviceKey } from "./deviceStore.js";

// Namespaced key, matching the `theme.tsx` convention on shared origins.
const STORAGE_KEY = "bilda.displayName";

export const readDisplayName = (): string => readDeviceKey(STORAGE_KEY) ?? "";

export const writeDisplayName = (name: string): void =>
    writeDeviceKey(STORAGE_KEY, name);
